import { createDocument, getAllData, updateDocumentByID } from 'apis/customApiHandler';
import Modal from 'components/Modal';
import Spinner from 'components/Spinner';
import Add from 'components/manage-dtp/add';
import ViewList from 'components/manage-dtp/viewList';
import useDebounce from 'hooks/useDebounce';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { BiCloudDownload } from 'react-icons/bi';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { Button, Input, Select } from 'styled';
import { TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import getFormattedDate, { exportFile } from 'utils/helpers';
import permissions from 'utils/permissionConstants';
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import exportExcel from 'utils/exportExcel';

const ManageDTP = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState()
  const [quarter, setQuarter] = useState()
  const [plans, setPlans] = useState({})
  const [searchQuery, setSearchQuery] = useState("");
  const [fleetMap, setFleetMap] = useState({});
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([])
  const currentUser = useSelector((state) => state.user.currentUser);
  const [page, setPage] = useState(1);
  const [preview, setPreview] = useState()
  // console.log(currentUser.userRole.permissions)
  const [selectedUsers, setSelectedUsers] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const debouncedValue = useDebounce(searchQuery, 1000);


  const { data: trainingMaterials } = useQuery(
    ['training-materials', debouncedValue && debouncedValue],
    () => getAllData('/training-material', { searchQuery: debouncedValue, active: true })
  );



  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);



  const getData = async()=>{
    console.log('called--');
    setIsLoading(true)
    try{
      const response = await createDocument('/manage-dtp/getData', {
        ...searchQuery !== "" && { searchQuery }, 
        dateFrom,
        dateTo, 
        ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),        limit: 20,
        page: page,
      })
    setPlans(response)
    } catch(err){
      console.log('err--',err);
    }
    setIsLoading(false)
  }

  useEffect(()=>{
    getData()
  }, [page])

  const getDownloadData = async () => {
    setDownloading(true)
    try {
      const fleetOptions = getFleetOptions() || []
      const hubOptions = getHubOptions() || []
      
      const response = await createDocument('/manage-dtp/getData', {
        ...searchQuery !== "" && { searchQuery }, 
        dateFrom,
        dateTo, 
        ...(selectedFleets?.includes("all")
        ? {
          fleets: fleetOptions.filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: hubOptions.filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
        limit: 10000, // Large limit to get all records
        page: 1,
      })

      if (response?.data && response.data.length > 0) {
        const exportData = response.data.map((item, index) => ({
          "S.N": index + 1,
          "Date": item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-GB") : "",
          "Fleet": item.fleet?.fleetName || "---",
          "Fleet City": item.fleet?.city || "---",
          "Hub": item.hub?.hubName || "---",
          "Trainer Name": item.trainerName || "---",
          "Participants": item.participants || 0,
          "Added By": item.createdBy?.name || "---",
          "Discussion Points": item.points?.map(p => p.description).join(", ") || "---",
          "Additional Points": item.comment || "---",
          "Driver Count": item.driverDetails?.length || 0,
        }))

        exportExcel(exportData, "DTP_Report", false)
      } else {
        toast.error("No data available to export")
      }
    } catch (err) {
      console.log('Download error:', err)
      toast.error("Failed to download report")
    } finally {
      setDownloading(false)
    }
  }


  const approveRequest = async(id)=>{
    const response = await updateDocumentByID("manage-dtp", id, {status: "Approved"})
  }

  // console.log("todate", new Date(dateFrom)?.getTime(), new Date().getTime())

  return (
    <div>
      <div className="mx-10 my-2 mb-5">
        <div className="mt-8 grid grid-cols-4 justify-start items-center gap-2 ">
        <label className="w-full py-3 col-span-2">
            Select Fleets
            <ReactSelect  
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if(allValues?.includes("clear")){
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if(!selectedFleets?.includes("all") && allValues.includes("all")){
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter(item => item.value!== "all")
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );
                
                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})
                
                setSelectedFleets(value.map((fleet) => fleet.value));
                }
            }
              name="fleets"
              isMulti = {true}
            />
          </label>
          <label className="w-full py-3 col-span-2">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if(allValues.includes("clear")){
                  setSelectedHubs([])
                  return;
                }
                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);

                  const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                  const mp = fleetMap;
                  selectedHubsData.map(hub=>{
                    if(selectedFleetCodes?.includes(hub.fleetCode)){
                    if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                  }})

                  setFleetMap(mp);
                  setSelectedHubs(["all"])
                } 
                else {
                  // console.log({value})
                  value = value.filter(value => value.value!== "all")
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);
                  // console.log({allValues})
                
                  const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                  const mp = {};
                  selectedHubsData.map(hub=>{
                    mp[hub.fleetCode] = [];
                  })

                  selectedHubsData.map(hub=>{
                    if(selectedFleetCodes?.includes(hub.fleetCode)){
                    if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                    mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                  }})

                  setFleetMap(mp);                  
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>
          <label className="w-full py-3">
            Trainer Name
            <Input
              type="text"
              name="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </label>
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              max={getFormattedDate(new Date(Math.max(new Date().getTime(), new Date(dateFrom)?.getTime())))}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
        </div>

        <div className=" flex justify-center items-center gap-4">
          <label className="w-full py-3">
            Download Training Material
            <ReactSelect
              // name="quarter"
              value={selectedDocs}
              // isMulti= {true}
              onChange={async (value) => {
                // console.log("DOCS", value);
                setSelectedDocs(value.value);
                const document = value?.value;
                // document?.map((item) => {
                //   exportFile(item, value.label + "_training_material");
                // });

                // console.log("file type", document[0].split(".").splice(-1)[0] );

                setPreview({url: document[0], fileType: document[0].split(".").splice(-1)[0]})
              }}
              options={trainingMaterials?.data?.map((document) => {
                return { label: document.name, value: document.documents };
              })}
            >
              <option disabled={true}> Select Training Material</option>
              {trainingMaterials?.data &&
                trainingMaterials?.data.map((document) => {
                  return (
                    <option
                      value={document.documents}
                      disabled={!document.documents?.length}
                      className={`items-center m-1 bg-yellow-500 bg-opacity-40 p-2 m-1 rounded-md   ${
                        !document.documents?.length
                          ? "text-gray-400"
                          : "text-green-500"
                      }`}
                    >
                      {document.name}
                    </option>
                  );
                })}
            </ReactSelect>
          </label>
          <Button
            type="button"
            className='mt-5'
            disabled={selectedHubs.length === 0 && !searchQuery}
            bgPrimary
            onClick={() => getData()}
          >
            Search
          </Button>
          <Button
            className="!px-8 mt-5 disabled:bg-gray-400"
            bgPrimary
            disabled={!checkPermission([permissions.create_dtp], currentUser)}
            onClick={() => setShowAddmodel(true)}
          >
            Add
          </Button>
          {downloading ? (
            <span className="mt-5 text-sm text-gray-500 flex items-center">
              Downloading...
            </span>
          ) : (selectedHubs.length > 0 || searchQuery) && (
            <BiCloudDownload
              className="w-10 h-10 mt-5 text-green-600 hover:text-green-700 hover:scale-110 cursor-pointer transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={getDownloadData}
              title="Download Report"
            />
          )}
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                  <h1 className='text-center'>Driver Details</h1>
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Date</TH>
                      <TH scope="col">Fleet</TH>
                      <TH scope="col">Hub</TH>
                      <TH scope="col">Trained By</TH>
                      <TH scope="col">Participants</TH>
                      {/* <TH scope="col">Created At</TH> */}
                      <TH scope="col">Added By</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {plans?.data &&
                      plans?.data.map((data, index) => (
                        <ViewList data={data} key={data._id} index={index} getData= {getData} page={page} 
                        fleetCity={data.city}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {plans && plans.paginate && plans.paginate.totalData && (
        <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          <Button
            onClick={() => {
              setPage((p) => Math.max(p - 1, 1));
            }}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>
          <span className="text-gray-600 px-4">{`showing: ${
            (page - 1) * 20 + 1
          } - ${Math.min(plans?.paginate?.totalData, page * 20)} of ${
            plans.paginate.totalData
          }`}</span>

          {plans.paginate.totalData > page * 20 && (
            <Button
              onClick={() => {
                setPage((p) => Math.min(p + 1, plans?.paginate?.totalPage));
              }}
              disabled={page === plans?.paginate?.totalPage}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                Next Page
                <IoMdArrowForward />
              </div>
            </Button>
          )}
        </div>
      )}
      {showAddmodel && (
        <Add
          handleClick={() => {
            setShowAddmodel(false);
            // getData();
          }}
        />
      )}
      {preview && 
      <Modal
      handleClick = {(e)=>{setPreview(null)}}>
        <div>
       <iframe className={preview.fileType} width="100%" height="800" frameborder="0" src={`${preview.url}`}></iframe>
       </div>
</Modal>}
    </div>
  );
};

export default ManageDTP;
